import React from 'react';

import { IconProps } from '@shared/ui/Icon/model/types';

export const CommentsIcon = ({ fill = '#D1D9E8', width = 48, height = 48 }: IconProps) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={width}
        height={height}
        viewBox="0 0 48 48"
        fill="none"
    >
        <path
            d="M6.68001 39.2795L14.606 33.9943H36V5.999C36 2.69155 33.308 0 30 0H6.00001C2.69201 0 7.32342e-06 2.69155 7.32342e-06 5.999V35.702C-0.00142989 36.4802 0.208697 37.2442 0.607919 37.9122C1.00714 38.5802 1.58045 39.1271 2.26653 39.4946C2.95262 39.862 3.72568 40.0361 4.50307 39.9982C5.28045 39.9603 6.03291 39.7119 6.68001 39.2795ZM48 13.9977V43.7007C48.0008 44.2654 47.8902 44.8246 47.6745 45.3465C47.4588 45.8683 47.1423 46.3425 46.743 46.7418C46.3438 47.1412 45.8697 47.4579 45.3479 47.6738C44.826 47.8897 44.2667 48.0005 43.702 48C42.87 48 42.04 47.758 41.322 47.2801L33.394 41.993H12V40.5392L15.816 37.9937H40V7.99867H42C45.308 7.99867 48 10.6902 48 13.9977Z"
            fill={fill}
        />
    </svg>
);
